import React, { useEffect, useMemo, useState } from "react";

import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PageURL from "../constants/PageURL";
import DiagonisticGuard from "./guard/DiagonisticGuard";
import Diagonistic from "./diagonisticModel/Diagonistic";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import "./countrymodule.css";
import { toast } from "react-toastify";
import {
  clear_errors,
  new_project_detail_request,
} from "../constants/dataConstants";
import { useMediaQuery, useTheme } from "@mui/material";
import { ProjectSidebar } from "./layout/ProjectSidebar";
import Header from "./Headers/Header";
import SubHeader from "./Headers/subHeader";
import SubHeader2 from "./Headers/subHeader2";
const CountryModule = () => {
  const { projectDetail, availableProject, loading2, error2 } = useSelector(
    (state) => state.projectDetail
  );
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(!isMobile);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    country: "",
    partnerName: "",
    projectName: "",
    projectDetail: "",

  });

  const [scbsmbDetail, setscbsmbDetail] = useState({
    block: null,
    inverter: null,
    inverterType: null,
    scbsmb: null,
    labelData: null,
    scbsmbType: null,
  });


  const [selectedLebel, sestSelectedLebel] = useState({
    startDate: null, endDate: null,
    dateRangeType: null,
    timeInterval: null,
    startTimestamp: null,
    endTimestamp: null
  });

  const serachParams = new URLSearchParams(location.search);

  const databaseStr = useMemo(() => {
    if (
      selectedValue.country &&
      selectedValue.partnerName &&
      selectedValue.projectName
    ) {
      return (
        selectedValue.country +
        selectedValue.partnerName +
        selectedValue.projectName
      )
        .split(" ")
        .join("");
    }
    return null;
  }, [selectedValue]);

  useEffect(() => {
    setSelectedValue({
      ...selectedValue,
      country: serachParams.get("country") || "",
      partnerName: serachParams.get("partner-name") || "",
      projectName: serachParams.get("project-name") || "",
    });
  }, []);

  useEffect(() => {
    if (selectedValue.country) {
      serachParams.set("country", selectedValue.country);
    } else {
      ["country", "partner-name", "project-name", "project-detail"].forEach(
        (e) => serachParams.delete(e)
      );
    }
    if (selectedValue.partnerName) {
      serachParams.set("partner-name", selectedValue.partnerName);
    } else
      ["partner-name", "project-name", "project-detail"].forEach((e) =>
        serachParams.delete(e)
      );
    if (selectedValue.projectName) {
      serachParams.set("project-name", selectedValue.projectName);
    } else
      ["project-name", "project-detail"].forEach((e) => serachParams.delete(e));
    if (selectedValue.projectDetail) {
      serachParams.set("project-detail", selectedValue.projectDetail);
    } else["project-detail"].forEach((e) => serachParams.delete(e));
    navigate(`${location.pathname}?${serachParams.toString()}`);
    if (
      (!selectedValue.country ||
        !selectedValue.partnerName ||
        !selectedValue.projectName) &&
      projectDetail
    ) {
      dispatch({ type: new_project_detail_request });
    }
  }, [navigate, selectedValue, dispatch]);

  useEffect(() => {
    if (error2) {
      toast.error(error2);
      dispatch({ type: clear_errors });
      navigate(PageURL.COUNTRYDEFAULT)
    }
  }, [error2, navigate, dispatch]);

  if (
    location.pathname !== PageURL.PROJECT_DETAILS &&
    !projectDetail &&
    location.pathname !== PageURL.COUNTRYDEFAULT && location.pathname !== PageURL.ADMIN_DASHBOARD
  ) {

    return (
      <Navigate to={`${PageURL.PROJECT_DETAILS}?${serachParams.toString()}`} />
    );
  }


  return (
    <ProjectSidebar
      open={open}
      setOpen={setOpen}
      databaseStr={databaseStr}
      selectedLebel={selectedLebel}
      sestSelectedLebel={sestSelectedLebel}
      scbsmbDetail={scbsmbDetail}
      setscbsmbDetail={setscbsmbDetail}
      openSidebar={openSidebar}
      setOpenSidebar={setOpenSidebar}
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      children={
        <DiagonisticGuard>
          <Header open={open} />
          {
            location.pathname !== PageURL.ADMIN_DASHBOARD && !location.pathname.includes("forecasting")  && !location.pathname.includes("predictive") &&
            <SubHeader open={open} selectedValue={selectedValue} selectedLebel={selectedLebel} sestSelectedLebel={sestSelectedLebel} />
          }
          {
            (location.pathname.includes("forecasting") || location.pathname.includes("predictive")) && <SubHeader2 open={open} selectedValue={selectedValue} selectedLebel={selectedLebel} sestSelectedLebel={sestSelectedLebel} />
          }

          <Diagonistic
            databaseStr={databaseStr}
            selectedLebel={selectedLebel}
            sestSelectedLebel={sestSelectedLebel}
            setscbsmbDetail={setscbsmbDetail}
            scbsmbDetail={scbsmbDetail}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
          />
        </DiagonisticGuard>
      }
    />
  );
};

export default CountryModule;
